// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"3ec61064","300":"a713cc2f","799":"05fc9e3d"}[chunkId] + ".chunk.css";
};